<div infiniteScroll [fromRoot]="true"
     [infiniteScrollContainer]="'mat-sidenav-content'"
     [infiniteScrollDistance]="2"
     (scrolled)="onScroll()">


  <div *ngFor="let postState of (postsState$ | async); trackBy: trackByFn">
    <anms-post
      [postState]="postState"
      (createCommentEvent)="createComment($event)"
      (upVotePostEvent)="upVotePost($event)"
      (downVotePostEvent)="downVotePost($event)"
      (upVoteCommentEvent)="upVoteComment($event)"
      (downVoteCommentEvent)="downVoteComment($event)"
      (showCommentsEvent)="showComments($event)"
      (hideCommentsEvent)="hideComments($event)"
      (loadMoreCommentsEvent)="loadMoreComments($event)"
      (deletePostEvent)="deletePost($event)"
      (deleteCommentEvent)="deleteComment($event)"
      (favouritePostEvent)="favouritePost($event)"
      (unFavouritePostEvent)="unFavouritePost($event)"
      (castForPollEvent)="castForPoll($event)"
      (unVotePostEvent)="unVotePost($event)"
      (echoPostEvent)="echoPost($event)"
      (showReplyCommentEvent)="showReplyComment($event)"
      (createCommentReplyEvent)="createCommentReply($event)"
      (hideReplyCommentsEvent)="hideReplyComments($event)"
      (loadMoreReplyCommentsEvent)="loadMoreReplyComments($event)"
      (deleteReplyCommentEvent)="deleteReplyComment($event)"
      (upVoteReplyCommentEvent)="upVoteReplyComment($event)"
      (downVoteReplyCommentEvent)="downVoteReplyComment($event)"
      (selectedGiphyEvent)="selectedCommentGiphy($event)">
    </anms-post>
    <!-- <anms-follow-strip></anms-follow-strip> -->
  </div>


  <div>
    <mat-progress-bar mode="query" *ngIf="postStateLoading$ | async" class="mb-5"></mat-progress-bar>
  </div>


  <!--  empty post content-->
  <div class="mt-4 mb-4"
       *ngIf="!(postStateLoading$ | async) && !(postMorePostsError$ | async)
       && (postsState$ | async)?.length <= 0 && showPostEmpty">
    <img class="w-50 h-50 img-fluid  mx-auto d-block" src="../../../../assets/images/states/no-posts.svg" alt="">
    <h6 class="text-muted text-center p-3">No posts yet!</h6>
  </div>
  <!--  End of empty post content-->


  <!--  timeline empty state-->
  <div *ngIf="!(postStateLoading$ | async) && showTimeLineEmpty && (postsState$ | async)?.length <= 0">

    <div class="mt-4 mb-4" *ngIf="!(isAuthenticated$ | async)">
      <img class="w-50 h-50 img-fluid  mx-auto d-block" src="../../../../assets/images/states/no-following.svg"
           alt="no following">
      <h6 class="text-muted text-center p-3">You need to register/login, to view your timeline!</h6>
    </div>


    <div class="mt-4 mb-4" *ngIf="(isAuthenticated$ | async)">
      <img class="w-50 h-50 img-fluid  mx-auto d-block" src="../../../../assets/images/states/no-following.svg" alt="">
      <h6 class="text-muted text-center p-3">Find people to follow then check back here!</h6>
    </div>

    <div class="d-flex justify-content-center m-2">
      <button mat-button routerLink="/auth/login" color="accent" *ngIf="!(isAuthenticated$ | async)">
        Login
        <mat-icon>login</mat-icon>
      </button>
      <button mat-button routerLink="/auth/signup" color="warn" *ngIf="!(isAuthenticated$ | async)">
        SignUp
        <mat-icon>exit_to_app</mat-icon>
      </button>
      <button mat-button routerLink="/connect" color="primary" *ngIf="isAuthenticated$ | async">
        Connect
        <mat-icon>people</mat-icon>
      </button>
      <button mat-button routerLink="/discover" color="accent" *ngIf="isAuthenticated$ | async">
        Discover
        <mat-icon>face</mat-icon>
      </button>
    </div>
  </div>
  <!-- end timeline empty state-->


  <!--  search post empty state-->
  <div class="mt-4 mb-4"
       *ngIf="!(postStateLoading$ | async) && !(postMorePostsError$ | async)
       && (postsState$ | async)?.length <= 0 && showSearchEmpty">
    <img class="w-50 h-50 img-fluid  mx-auto d-block" src="../../../../assets/images/states/no-search.svg"
         alt="No Post Image">
    <h6 class="text-muted text-center p-3">No posts found!</h6>
  </div>


  <!--  <div *ngIf="!(postStateLoading$ | async) && (postMorePostsError$ | async)" class="mt-4 mb-4">-->
  <!--    <img class="w-50 h-50 img-fluid  mx-auto d-block" src="../../../../assets/images/states/more-posts.svg" alt="">-->
  <!--    <h6 class="text-muted text-center p-3">That's all the posts we have for you.</h6>-->
  <!--  </div>-->

  <div class="d-flex justify-content-center m-2"
       *ngIf="!(postStateLoading$ | async) &&  !(isAuthenticated$ | async) && showLoginToLoadMore">
    <button mat-button routerLink="/auth/login" color="warn"> Please Login to load more content</button>
  </div>


</div>
